import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationCommunicationService {
  private childDataSubject = new Subject<any>();

  // Observable for subscribers
  childData$ = this.childDataSubject.asObservable();

  // Method to emit data
  sendData(data: any) {
    this.childDataSubject.next(data);
  }
}